import { useAnalytics } from '@magnetic/analytics';
import { useCallback } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useButtonClick = /* @__PURE__ */ __name(({
  analytics,
  disabled,
  onClick
}) => {
  const { sendAnalytics } = useAnalytics();
  return useCallback(
    (evt) => {
      var _a;
      const isLink = ((_a = evt.target) == null ? void 0 : _a.nodeName) === "A";
      if ((analytics == null ? void 0 : analytics.events.includes("click")) && !disabled) {
        sendAnalytics({
          ...analytics,
          component: isLink ? "link" : "button",
          event: "click"
        });
      }
      onClick == null ? void 0 : onClick(evt);
    },
    [analytics, disabled, onClick, sendAnalytics]
  );
}, "useButtonClick");

export { useButtonClick };
//# sourceMappingURL=use-button-click.js.map
